import { render, staticRenderFns } from "./LiveVideo.vue?vue&type=template&id=79d6ad04&"
import script from "./LiveVideo.vue?vue&type=script&lang=js&"
export * from "./LiveVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\lr-statics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d6ad04')) {
      api.createRecord('79d6ad04', component.options)
    } else {
      api.reload('79d6ad04', component.options)
    }
    module.hot.accept("./LiveVideo.vue?vue&type=template&id=79d6ad04&", function () {
      api.rerender('79d6ad04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/live-video/LiveVideo.vue"
export default component.exports